import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, vModelSelect as _vModelSelect, mergeProps as _mergeProps, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["multiple"]

import { computed, type HTMLAttributes } from 'vue';
import { cn } from '@/lib/utils';

export default /*@__PURE__*/_defineComponent({
  ...{ inheritAttrs: false },
  __name: 'NativeSelect',
  props: {
    modelValue: {},
    multiple: { type: Boolean },
    class: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {


const props = __props;
const emit = __emit;
const model = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value),
});

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("select", _mergeProps(_ctx.$attrs, {
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
    multiple: __props.multiple,
    class: _unref(cn)('ui-select', props.class)
  }), [
    _renderSlot(_ctx.$slots, "default")
  ], 16, _hoisted_1)), [
    [_vModelSelect, model.value]
  ])
}
}

})